import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useAttachmentsConfig } from './useAttachmentsConfig';

export const useFileDownload = (): UseMutationResult<AxiosResponse, unknown, string> => {
    const { downloadFile, downloadInternalFile, isInternalView } = useAttachmentsConfig();

    const downloadFn = isInternalView && downloadInternalFile ? downloadInternalFile : downloadFile;

    return useMutation({
        mutationFn: (fileId: string) => downloadFn(fileId),
    });
};
